import { makeFmtMoney } from "@plannel/components/dashboard/dashboardFormat";

// AI 화면 금액 표기 — 회사 기본 통화(회사 정보 화면, localStorage user.currencyCd) 기호 + T/B/M/K(makeFmtMoney).
// 호출 시점마다 localStorage 를 읽는다(모듈 로드 시 고정하면 로그인·통화 변경이 반영되지 않는다).
const userCurrencyCd = () => {
  try {
    return JSON.parse(localStorage.getItem("user"))?.currencyCd || null;
  } catch {
    return null;
  }
};

export const fmtMoney = (v) => {
  if (v == null || v === "" || !isFinite(Number(v))) return null;
  const n = Number(v);
  const body = makeFmtMoney(userCurrencyCd())(Math.abs(n));
  return n < 0 && body.match(/[1-9]/) ? `-${body}` : body;
};

// 증감 표기 — 부호를 통화 기호 앞에 둔다("+₩1.2M").
export const fmtSignedMoney = (v) => {
  const body = fmtMoney(v);
  if (body == null) return null;
  return Number(v) > 0 ? `+${body}` : body;
};
